import { render, staticRenderFns } from "./InvoiceInbounds.vue?vue&type=template&id=273cbfb8&"
import script from "./InvoiceInbounds.vue?vue&type=script&lang=js&"
export * from "./InvoiceInbounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports